<script setup>
import YTCard from "@/components/YTCard/YTCard.vue";

const props = defineProps({
  drawerCacheInfo: {
    required: true,
    type: Object,
    default: {}
  }
})

// 选中的属性值颜色区分
const handleTagType = (index) => {
  const enumList = ['primary', 'success', 'warning', 'danger']
  return enumList[index % 4]
}
</script>

<template>
  <el-form label-position="right" label-width="auto">
    <YTCard :title="'基本信息'">
      <template #container>
        <el-form-item label="商品名称：">
          <span>{{props.drawerCacheInfo.goodsName}}</span>
        </el-form-item>
        <el-form-item label="商品编码：">
          <span>{{props.drawerCacheInfo.barCode}}</span>
        </el-form-item>
        <el-form-item label="商品分类：">
          <span>{{props.drawerCacheInfo.innerCategoryName}}</span>
        </el-form-item>
        <el-form-item label="商品图片：">
          <el-image v-for="(item, index) in props.drawerCacheInfo.images" :key="`props.drawerCacheInfo.images${index}`" style="width: 100px; height: 100px" :src="item" fit="contain" />
        </el-form-item>
        <el-form-item label="商品描述：">
          <div class="ql-editor" v-html="props.drawerCacheInfo.description"></div>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'扩展信息'" v-if="props.drawerCacheInfo.innerCategoryType === 'COMPETITION' || props.drawerCacheInfo.innerCategoryType === 'COURSE' || props.drawerCacheInfo.innerCategoryType === 'VOUCHER' || props.drawerCacheInfo.innerCategoryType === 'COUPON'">
      <template #container>
        <div v-if="props.drawerCacheInfo.innerCategoryType === 'COMPETITION'">
          <el-form-item label="主办方：">
            <span>{{props.drawerCacheInfo.organizerName}}</span>
          </el-form-item>
          <el-form-item label="报名网址：">
            <span>{{props.drawerCacheInfo.applyUrl}}</span>
          </el-form-item>
          <div v-if="props.drawerCacheInfo.bizType === 5">
            <el-form-item label="组别设置：">
              <div class="w-100" v-for="(item, index) in props.drawerCacheInfo.competitionDivisions">
                <div>{{ item.divisionName }}</div>
                <div>报名费：￥{{ item.entryFee }}</div>
                <div>距离：{{ item.distance }} KM</div>
                <div>爬升：{{ item.elevationGain }} M</div>
                <el-divider></el-divider>
              </div>
            </el-form-item>
            <el-form-item label="配套服务：">
              <div class="w-100" v-for="(item, index) in props.drawerCacheInfo.groups" :key="`groups${index}`">
                <div>{{item.groupType === "FIXED" ? "固定组" : "可选组"}}</div>
                <div>服务名称：{{item.groupName}}</div>
                <div>
                  关联商品：<span v-for="(sonItem, sonIndex) in item.items" :key="`groupsItems${index}${sonIndex}`">{{sonItem.goodsName }}</span>
                </div>
                <el-divider v-if="index + 1 !== props.drawerCacheInfo.groups.length"></el-divider>
              </div>
            </el-form-item>
          </div>
        </div>
        <div v-if="props.drawerCacheInfo.innerCategoryType === 'COURSE'">
          <el-form-item label="课堂人数：">
            <span>{{props.drawerCacheInfo.studentLimit}}人</span>
          </el-form-item>
          <el-form-item label="课堂时长：">
            <span>{{props.drawerCacheInfo.courseDuration}}分钟</span>
          </el-form-item>
          <el-form-item label="有效期：">
            <span v-if="props.drawerCacheInfo.validityType === 'PERMANENT'">长期有效</span>
            <span v-else-if="props.drawerCacheInfo.validityType === 'DAYS'">{{props.drawerCacheInfo.validityValue}}天</span>
            <span v-else-if="props.drawerCacheInfo.validityType === 'END_DATE'">{{props.drawerCacheInfo.validityValue}}</span>
          </el-form-item>
        </div>
        <div v-if="props.drawerCacheInfo.innerCategoryType === 'VOUCHER'">
          <el-form-item label="关联商品：">
            <span>{{ props.drawerCacheInfo.voucherInfo.relatedGoods?.relatedGoodsName }}</span>
          </el-form-item>
          <el-form-item label="有效期：">
            <span v-if="props.drawerCacheInfo.voucherInfo.validityType === 'PERMANENT'">长期有效</span>
            <span v-else-if="props.drawerCacheInfo.voucherInfo.validityType === 'DAYS'">{{props.drawerCacheInfo.voucherInfo.validityValue}}天</span>
            <span v-else-if="props.drawerCacheInfo.voucherInfo.validityType === 'END_DATE'">{{props.drawerCacheInfo.voucherInfo.validityValue}}</span>
          </el-form-item>
        </div>
        <div v-if="props.drawerCacheInfo.innerCategoryType === 'COUPON'">
          <el-form-item label="订单金额：">
            <span>￥{{props.drawerCacheInfo.couponInfo.minimumOrderAmount}}</span>
          </el-form-item>
          <el-form-item label="抵扣金额：">
            <span>￥{{props.drawerCacheInfo.couponInfo.discountAmount}}</span>
          </el-form-item>
          <el-form-item label="有效期：">
            <span v-if="props.drawerCacheInfo.couponInfo.validityType === 'PERMANENT'">长期有效</span>
            <span v-else-if="props.drawerCacheInfo.couponInfo.validityType === 'DAYS'">{{props.drawerCacheInfo.couponInfo.validityValue}}天</span>
            <span v-else-if="props.drawerCacheInfo.couponInfo.validityType === 'END_DATE'">{{props.drawerCacheInfo.couponInfo.validityValue}}</span>
          </el-form-item>
        </div>

      </template>
    </YTCard>
    <YTCard :title="'价格库存'" :is-show-divider="props.drawerCacheInfo.bizType !== 3 && props.drawerCacheInfo.bizType !== 4">
      <template #container>
        <el-form-item label="零售价格：">
          <span>￥{{props.drawerCacheInfo.retailPrice}}</span>
        </el-form-item>
        <el-form-item label="成本价格：">
          <span>￥{{props.drawerCacheInfo.costPrice}}</span>
        </el-form-item>
        <el-form-item label="使用次数：" v-if="(props.drawerCacheInfo.bizType === 2 && props.drawerCacheInfo.innerCategoryType === 'COURSE') || props.drawerCacheInfo.bizType === 3 || props.drawerCacheInfo.bizType === 4">
          <span>{{props.drawerCacheInfo.usageCount}}</span>
        </el-form-item>
        <el-form-item label="积分价格：" v-if="props.drawerCacheInfo.bizType === 3 || props.drawerCacheInfo.bizType === 4">
          <span v-if="props.drawerCacheInfo.bizType === 3">{{props.drawerCacheInfo.voucherInfo.pointsPrice}}</span>
          <span v-if="props.drawerCacheInfo.bizType === 4">{{props.drawerCacheInfo.couponInfo.pointsPrice}}</span>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'商品属性'" v-if="props.drawerCacheInfo.bizType !== 3 && props.drawerCacheInfo.bizType !== 4">
      <template #container>
        <div v-if="props.drawerCacheInfo.bizType === 1">
          <el-form-item label="商品属性：">
            <div v-if="props.drawerCacheInfo.propertyGroupList.length > 0">
              <div class="w-100" :key="`propertyGroupList${index}`" v-for="(item, index) in props.drawerCacheInfo.propertyGroupList">
                <div>{{item.groupName}}</div>
                <el-tag class="mg_r_1" v-for="(son, sonIndex) in item.propertyGroupItemList" :key="`itemPropTag${item.name}${sonIndex}`" :type="handleTagType(sonIndex)">{{son.propertyName}}</el-tag>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </el-form-item>
        </div>
        <div v-if="props.drawerCacheInfo.bizType === 2">
          <div v-if="props.drawerCacheInfo.innerCategoryType === 'ACTIVITY'">
            <el-form-item label="有效时间：">
              <span>{{props.drawerCacheInfo.startTime && props.drawerCacheInfo.endTime ? `${props.drawerCacheInfo.startTime} - ${props.drawerCacheInfo.endTime}` : '-'}}</span>
            </el-form-item>
          </div>
          <div v-else-if="props.drawerCacheInfo.innerCategoryType === 'COMPETITION'">
            <el-form-item label="报名时间：">
              <span>{{props.drawerCacheInfo.applyStartTime && props.drawerCacheInfo.applyEndTime ? `${props.drawerCacheInfo.applyStartTime} - ${props.drawerCacheInfo.applyEndTime}` : '-'}}</span>
            </el-form-item>
            <el-form-item label="比赛时间：">
              <span>{{props.drawerCacheInfo.startTime && props.drawerCacheInfo.endTime ? `${props.drawerCacheInfo.startTime} - ${props.drawerCacheInfo.endTime}` : '-'}}</span>
            </el-form-item>
          </div>
          <el-form-item label="城市：" v-if="props.drawerCacheInfo.innerCategoryType === 'ACTIVITY' || props.drawerCacheInfo.innerCategoryType === 'COURSE' || props.drawerCacheInfo.innerCategoryType === 'COMPETITION'">
            <span>{{props.drawerCacheInfo.city}}</span>
          </el-form-item>
          <el-form-item label="商品属性：">
            <div v-if="props.drawerCacheInfo.goodsVirtualItemList.length > 0">
              <div class="w-100" v-for="(item, index) in props.drawerCacheInfo.goodsVirtualItemList" :key="`props.drawerCacheInfo.goodsVirtualItemList${index}`">
                <div class="flex flex_left">
                  <div style="padding-right: 12px;text-align: right" v-text="`${item.name}:`"></div>
                  <div class="mg_r_2" v-text="item.content"></div>
                </div>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </el-form-item>
        </div>
        <div v-if="props.drawerCacheInfo.bizType === 5">
          <div v-if="props.drawerCacheInfo.innerCategoryType === 'ACTIVITY'">
            <el-form-item label="有效时间：">
              <span>{{props.drawerCacheInfo.startTime && props.drawerCacheInfo.endTime ? `${props.drawerCacheInfo.startTime} - ${props.drawerCacheInfo.endTime}` : '-'}}</span>
            </el-form-item>
          </div>
          <div v-else-if="props.drawerCacheInfo.innerCategoryType === 'COMPETITION'">
            <el-form-item label="报名时间：">
              <span>{{props.drawerCacheInfo.applyStartTime && props.drawerCacheInfo.applyEndTime ? `${props.drawerCacheInfo.applyStartTime} - ${props.drawerCacheInfo.applyEndTime}` : '-'}}</span>
            </el-form-item>
            <el-form-item label="比赛时间：">
              <span>{{props.drawerCacheInfo.startTime && props.drawerCacheInfo.endTime ? `${props.drawerCacheInfo.startTime} - ${props.drawerCacheInfo.endTime}` : '-'}}</span>
            </el-form-item>
          </div>
          <el-form-item label="城市：" v-if="props.drawerCacheInfo.innerCategoryType === 'ACTIVITY' || props.drawerCacheInfo.innerCategoryType === 'COURSE' || props.drawerCacheInfo.innerCategoryType === 'COMPETITION'">
            <span>{{props.drawerCacheInfo.city}}</span>
          </el-form-item>
          <el-form-item label="商品属性：">
            <div v-if="props.drawerCacheInfo.goodsVirtualItemList.length > 0">
              <div class="w-100" v-for="(item, index) in props.drawerCacheInfo.goodsVirtualItemList" :key="`props.drawerCacheInfo.goodsVirtualItemList${index}`">
                <div class="flex flex_left">
                  <div style="padding-right: 12px;text-align: right" v-text="`${item.name}:`"></div>
                  <div class="mg_r_2" v-text="item.content"></div>
                </div>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </el-form-item>
        </div>
      </template>
    </YTCard>
  </el-form>
</template>

<style scoped>

</style>
